import {
  FETCH_REFERRAL_TYPES,
  FETCH_REFERRAL_TYPES_SUCCESS,
  FETCH_REFERRAL_TYPES_FAILED,
  EDIT_REFERRAL_TYPE
} from "../store/types";

const INITIAL_STATE = {
  referrals: null,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const referralsreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_REFERRAL_TYPES:
      return {
        ...state,
        loading: true
      };
    case FETCH_REFERRAL_TYPES_SUCCESS:
      return {
        ...state,
        referrals: action.payload,
        loading: false
      };
    case FETCH_REFERRAL_TYPES_FAILED:
      return {
        ...state,
        referrals: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_REFERRAL_TYPE:
      return state;
    default:
      return state;
  }
};